// extracted by mini-css-extract-plugin
module.exports = {"successContainer":"styles_successContainer__JA7Bd","successIcon":"styles_successIcon__yz15T","successTitle":"styles_successTitle__gNhjl","successText":"styles_successText__xqAip"};
module.exports.__checksum = "b562c1287661"